import React, { useEffect, useState } from "react";
import { useForm } from 'react-hook-form';

// components
import { Button, Card, CardBody, CardHeader, FormGroup, Form, Input, Row, Col, Spinner } from "reactstrap";
import Select from 'react-select'

// helpers
import { showMessage } from "../../helpers/message.js";

// api
import contrato_api from "../../api/contrato_api.js";

export default function AditivosReajustes({ history }) {
    const { register, errors, handleSubmit, setValue, clearErrors, getValues } = useForm({ mode: "onBlur" });
    
    const [showLoading, setshowLoading] = useState(false);
    
    const [contratosVigentes, setContratosVigentes] = useState([]);

    const [contratoSelecionado, setContratoSelecionado] = useState()

    const [tipo, setTipo] = useState(null);

    const [anexo, setAnexo] = useState([]);

    const options_tipo = [
        { value: "Aditivo", label: "Aditivo" },
        { value: "Reajuste", label: "Reajuste" },
    ];

    const handleChange = (value) => {
        setTipo(value);
        setValue("tipo", value, true);
    }
    
    const loadOptionsContratos = () => {
        contrato_api.getAllVigentes().then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
                return;
            }
            else {
                setContratosVigentes(result.data);
            }
        })
    }

    const handleChangeAnexo = (event) => {
        event.preventDefault();
        if (event.target.files.length) {
            const file = event.target.files[0];
            const fsize = Math.round((file.size / 1024));

            if (fsize == 0) {
                showMessage("Aviso", "Arquivo selecionado inválido. Tamanho do aquivo: " + fsize + "MB", 'error', null);
                return;
            }

            if (file.type != "application/pdf") {
                showMessage("Aviso", "Formato do arquivo " + file.type + " inválido. O arquivo deve estar no formato pdf.", 'error', null);
                return;
            }

            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onloadend = function () {
                var base64data = reader.result;
                setAnexo(base64data.replace("data:application/pdf;base64,", ""))
                setValue("anexo", base64data.replace("data:application/pdf;base64,", ""), true);
            }
        }
    }

    const handleChangeContratosVigentes = (value) => {
        setContratoSelecionado(value);
        setValue("contratoSelecionado", value, true);
    }

    const onSubmit = (data) => {
        const json_submit = {
            contratoId: contratoSelecionado.contrato_Id,
            tipo: tipo.value,
            anexo: anexo
        }
        
        setshowLoading(true);
        contrato_api.postContratoAditivo(json_submit).then(response => {
            if (response.status !== 200) {
                showMessage("Aviso", response.message, 'error', null);
                return;
            }
            showMessage("Sucesso", "Aditivo/Reajuse adicionado com sucesso!", 'success', () => {window.location.reload()});
        }).finally(f => setshowLoading(false));
    }

    useEffect(() => {
        loadOptionsContratos();
    }, []);

    return (
        <>
            {showLoading &&
                <div className="carregandoCmp">
                    <div className="box">
                        <Spinner></Spinner>
                    </div>
                </div>
            }
            <div className="content">
                <Row>
                    <Col md="12">
                        <Card className="mt-4">
                            <CardHeader>
                                <h4 className="titleCard">Adicionar Aditivos e Reajustes</h4>
                            </CardHeader>
                            <CardBody>
                                <Form onSubmit={handleSubmit(onSubmit)}>
                                    <Row className="mb-4 align-items-end">
                                        <Col lg="6" md="6" sm="12">
                                            <FormGroup>
                                                <label className="form-control-label">Contratos Vigentes</label>
                                                <Select
                                                    name="contratoSelecionado"
                                                    options={contratosVigentes}
                                                    getOptionLabel={o => o.identificacao}
                                                    getOptionValue={o => o.contrato_Id}
                                                    value={contratoSelecionado}
                                                    onChange={(o) => handleChangeContratosVigentes(o)}
                                                    classNamePrefix="select"
                                                    placeholder="[ Selecione ]"
                                                    ref={e => register(
                                                        { name: "contratoSelecionado" },
                                                        { required: true })
                                                    }
                                                />
                                                {errors.contratoSelecionado && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col lg="4" md="6" sm="12">
                                            <FormGroup>
                                                <label className="form-control-label">Tipo</label>
                                                <Select
                                                    name="tipo"
                                                    options={options_tipo}
                                                    getOptionLabel={o => o.label}
                                                    getOptionValue={o => o.value}
                                                    value={tipo}
                                                    onChange={(o) => handleChange(o)}
                                                    classNamePrefix="select"
                                                    placeholder="[ Selecione ]"
                                                    ref={e => register(
                                                        { name: "tipo" },
                                                        { required: true })
                                                    }
                                                />
                                                {errors.tipo && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col lg="4" md="12" sm="12">
                                            <FormGroup>
                                                <label className="form-control-label">Anexar Arquivo de Aditivo/Reajuste</label>
                                                <Input 
                                                    name="anexo"
                                                    className="form-control"
                                                    autocomplete="off"
                                                    type="file"
                                                    onChange={(event) => handleChangeAnexo(event)}
                                                    ref={e => register(
                                                        { name: "anexo" },
                                                        { required: true })
                                                    }
                                                />
                                                {errors.anexo && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col lg="12" md="12" sm="12" className="text-center">
                                            <Button color="info" type="submit"><i className="fas fa-search"></i> Salvar</Button>
                                        </Col>
                                    </Row>
                                    
                                </Form>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        </>

    );
}